import { useContext } from 'react';

import { KeycloakContext } from 'components/Secured';

// Retailer org slug ('apotea' | 'ica' | 'coop' | 'wolt' | ...) for a logged-in
// admin, read from their Keycloak group '/organizations/{org}'. Returns null for
// non-admins or admins without an organization group. If an admin belongs to
// multiple org groups, the first match wins. Mirrors the group parsing in
// pages/shared/Products.js and the backend userGroupInfo.parent.
export const useAdminOrg = (): string | null => {
  const keycloakCtx = useContext(KeycloakContext);
  const keycloak = keycloakCtx?.keycloak;
  if (!keycloak?.hasResourceRole?.('admin')) return null;

  const groups: string[] = keycloak?.idTokenParsed?.groups || [];
  const orgGroup = groups.find(g => g.startsWith('/organizations/'));
  return orgGroup?.split('/')[2] || null;
};

export default useAdminOrg;
